import { IGameType } from '@/pages/intelligence/types/common';
import type { ITopChartsTypeOfCompanies } from '../types';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { IPO_STATUSES } from '@/pages/intelligence/components/TeaSelector/IPOStatusSelector';

export const TOP_CHARTS_TYPE_KEYS_MAPPING: {
  [key in ITopChartsTypeOfCompanies]: string;
} = {
  top_companies_revenue: 'revenue',
  top_companies_downloads: 'downloads',
  top_companies_mentions: 'mentions',
};

export const TOP_CHARTS_TYPE_NAMES_MAPPING: {
  [key in ITopChartsTypeOfCompanies]: string;
} = {
  top_companies_revenue: 'dbi_revenue',
  top_companies_downloads: 'dbi_downloads',
  top_companies_mentions: 'dbi_mentions',
};

export const DEFAULT_GAME_TYPES_MAPPING: {
  [key in ITopChartsTypeOfCompanies]: IGameType[];
} = {
  top_companies_revenue: ['mobile', 'pc', 'console'],
  top_companies_downloads: ['mobile'],
  top_companies_mentions: ['mobile'],
};

export const COLUMNS_SORT_METADATAS_MAPPING: {
  [key: string]: {
    dataSource: string;
    key: string;
    title: string;
    ratioSortable: boolean;
    entityType?: string;
    source?: string;
    mertricKey?: string;
  };
} = {
  SUM_REVENUE: {
    dataSource: '',
    key: 'total_revenue',
    title: 'dbi_company_metrics_sum_revenue',
    ratioSortable: true,
  },
  MOBILE_REVENUE: {
    dataSource: 'appannie',
    key: 'mobile_revenue',
    title: 'dbi_company_metrics_mobile_revenue',
    ratioSortable: true,
    entityType: 'mobile',
    mertricKey: 'company_revenue',
  },
  PC_REVENUE: {
    dataSource: 'Mscience_Npd',
    key: 'pc_revenue',
    title: 'dbi_company_metrics_pc_revenue',
    ratioSortable: true,
    entityType: 'pc',
    source: 'mscience,npd',
    mertricKey: 'company_revenue',
  },
  CONSOLE_REVENUE: {
    dataSource: 'Mscience_Npd',
    key: 'console_revenue',
    title: 'dbi_company_metrics_console_revenue',
    ratioSortable: true,
    entityType: 'console',
    source: 'mscience,npd',
    mertricKey: 'company_revenue',
  },
  DOWNLOADS: {
    dataSource: 'appannie',
    key: 'downloads',
    title: 'dbi_downloads',
    ratioSortable: true,
    mertricKey: 'company_downloads',
  },
  MENTIONS: {
    dataSource: 'rention',
    key: 'mentions',
    title: 'dbi_mentions',
    ratioSortable: false,
  },
};

export const TOP_CHARTS_TYPE_DEFAULT_SORT: {
  [key in ITopChartsTypeOfCompanies]: {
    dataSource: string;
    key: string;
  };
} = {
  top_companies_revenue: COLUMNS_SORT_METADATAS_MAPPING.SUM_REVENUE,
  top_companies_downloads: COLUMNS_SORT_METADATAS_MAPPING.DOWNLOADS,
  top_companies_mentions: COLUMNS_SORT_METADATAS_MAPPING.MENTIONS,
};

export const PAGE_LOG_CONFIG_KEYS_MAPPING: {
  [key in ITopChartsTypeOfCompanies]: string;
} = {
  top_companies_revenue: 'topchartsCompanyRevenue',
  top_companies_downloads: 'topchartsCompanyDownloads',
  top_companies_mentions: 'topchartsCompanyMentions',
};

export const PAGE_DOWNLOAD_FORM_CONFIG_KEYS_MAPPING: {
  [key in ITopChartsTypeOfCompanies]: string;
} = {
  top_companies_revenue: 'companies-revenue',
  top_companies_downloads: 'companies-downloads',
  top_companies_mentions: 'companies-mentions',
};

export const DOWNLOAD_GAMES_TYPES_MAPPING: {
  [key: string]: string;
} = {
  mobile: 'Mobile',
  pc: 'PC',
  console: 'Console',
};

export const COMPANIES_DEFAULT_FILTER_VALUE = {
  [filterKeyMap.MY_FILTER]: {
    value: '',
  },
  [filterKeyMap.REGION]: {
    type: 'market',
    regions: [],
    markets: ['global'],
  },
  [filterKeyMap.GENRETOR]: {
    source: 'annie',
    mainGenres: [],
    subGenres: [],
  },
  [filterKeyMap.IPO_STATUS]: {
    value: [...IPO_STATUSES],
  },
  [filterKeyMap.COUNTRY]: {
    value: [], // headQuatersAllValues,
  },
  [filterKeyMap.RANGE_TIME]: {
    type: 'month',
    value: ['', ''],
  },
  [filterKeyMap.REVENUE_RANGE_UNIT]: {
    value: {
      min: { value: '', unit: 'M' },
      max: { value: '', unit: 'M' },
    },
  },
  [filterKeyMap.DATASOURCESIM]: {
    value: 'sensortower',
  },
  // [filterKeyMap.GAME_TYPE]: {
  //   value: isRevenue ? [...GAME_TYPES] : ['mobile'],
  // },
};
